import { Table } from '@mantine/core';

import { TRIGGERS_ANALYTICS_COLUMNS } from '../../../constants';
import { analyticsTypes } from '../../../types';

import { TriggersAnalyticsRow } from './AnalyticsDataRow';

type TriggersAnalyticsTableProps = {
  data: analyticsTypes.TriggersReport;
  pagesMap: Record<string, { name: string; platform: string }>;
};

export const TriggersAnalyticsTable = ({ data, pagesMap }: TriggersAnalyticsTableProps) => {
  const rows = data.map((item) => {
    const page = pagesMap[item.expertId];
    return {
      ...item,
      expert: page?.name ?? '—',
      platform: page ? page.platform.toUpperCase() : '—',
    };
  });

  return (
    <Table stickyHeader striped highlightOnHover withColumnBorders withTableBorder>
      <Table.Thead>
        <Table.Tr>
          {TRIGGERS_ANALYTICS_COLUMNS.map(({ key, label }) => (
            <Table.Th key={`header ${key}`} sx={{ textAlign: 'center' }}>
              {label}
            </Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {rows.map((row) => (
          <TriggersAnalyticsRow row={row} />
        ))}
      </Table.Tbody>
    </Table>
  );
};
